import type { ContentfulPlaceholderBoutiqueDetail } from '@/graphql/contentful/api';
import type { StoreHit } from '@/integrations/algolia/types';
import type { CmsExtraDataRecord } from '@/integrations/contentful';
import { renderContentfulSection } from '@/integrations/contentful';
import type { ContentfulData } from '@/integrations/contentful/types';

import type { cmsBoutiqueDetailItemType } from '../BoutiqueDetailView';
import { BoutiqueBanner } from './components/BoutiqueBanner/BoutiqueBanner';
import { BoutiqueDetails } from './components/BoutiqueDetails/BoutiqueDetails';
import { BoutiqueMap } from './components/BoutiqueMap/BoutiqueMap';
import { BoutiqueStory } from './components/BoutiqueStory/BoutiqueStory';
export type PhotoGalleryItem = {
  image: {
    url: string;
  };
};
export const renderContentfulBoutiqueDetailSection = (
  data: cmsBoutiqueDetailItemType,
  isLocalization: boolean,
  boutiqueHit: StoreHit,
  cmsExtraData: CmsExtraDataRecord,
  draftMode?: boolean,
) => {
  const section = renderContentfulSection(
    data as ContentfulData,
    undefined,
    cmsExtraData,
    draftMode,
  );
  if (section) {
    return section;
  }
  const type = (data as ContentfulPlaceholderBoutiqueDetail)?.type;
  switch (type) {
    case 'boutiqueDetailHeader':
      return <BoutiqueBanner boutiqueHit={boutiqueHit} />;
    case 'boutiqueDetails':
      return <BoutiqueDetails boutiqueHit={boutiqueHit} />;
    case 'boutiqueStory':
      return <BoutiqueStory boutiqueHit={boutiqueHit} />;
    case 'map':
      return (
        <BoutiqueMap boutiqueHit={boutiqueHit} islocalized={isLocalization} />
      );
    default:
      return null;
  }
};
